import { Fit } from "@seneca/image-service-client";

import { getDimensionFromCSSVar } from "seneca-common/utils/functions";

import type { ModuleDeviceRequirements } from "features/module/types";

import styles from "./components/common.module.scss";

export const minFontSize = 16;
export const maxFontSize = 22;
export const defaultFontSize = 18;

export const assetParameters = {
  default: {
    width: getDimensionFromCSSVar(styles.workedexampleimgwidth),
    height: getDimensionFromCSSVar(styles.workedexampleimgheight),
    fit: Fit.INSIDE
  }
};

export const DEVICE_REQUIREMENTS: ModuleDeviceRequirements = {
  minModuleWidth: 300
};
